var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "AddEquipmentForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.addEquipment($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Code",
                              "label-for": "mc-first-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Equipment Code",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-first-name",
                                            placeholder: "Equipment Code",
                                          },
                                          model: {
                                            value: _vm.assetCode,
                                            callback: function ($$v) {
                                              _vm.assetCode = $$v
                                            },
                                            expression: "assetCode",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Name",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Equipment Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "mc-last-name",
                                            placeholder: "Equipment Name",
                                          },
                                          model: {
                                            value: _vm.name,
                                            callback: function ($$v) {
                                              _vm.name = $$v
                                            },
                                            expression: "name",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Equipment Description",
                              "label-for": "mc-city",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "textarea-default",
                                placeholder: "Equipment Description",
                                rows: "3",
                              },
                              model: {
                                value: _vm.description,
                                callback: function ($$v) {
                                  _vm.description = $$v
                                },
                                expression: "description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Supplier",
                              "label-for": "mc-Supplier",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.supplierList,
                                "value-field": "id",
                                "text-field": "name",
                              },
                              model: {
                                value: _vm.supplierId,
                                callback: function ($$v) {
                                  _vm.supplierId = $$v
                                },
                                expression: "supplierId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: { label: "Staff", "label-for": "mc-Staff" },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.staffList,
                                "value-field": "id",
                                "text-field": "firstName",
                              },
                              model: {
                                value: _vm.staffId,
                                callback: function ($$v) {
                                  _vm.staffId = $$v
                                },
                                expression: "staffId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Purchase Date",
                              "label-for": "mc-purchase",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Purchase Date",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: { id: "example-purchase" },
                                          model: {
                                            value: _vm.purchaseDate,
                                            callback: function ($$v) {
                                              _vm.purchaseDate = $$v
                                            },
                                            expression: "purchaseDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Expiry Date",
                              "label-for": "mc-expiry",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Expiry Date",
                                rules: { notBeforePurchase: _vm.purchaseDate },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: { id: "example-expiry" },
                                          model: {
                                            value: _vm.lifeEndDate,
                                            callback: function ($$v) {
                                              _vm.lifeEndDate = $$v
                                            },
                                            expression: "lifeEndDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Maintenance Date",
                              "label-for": "mc-Maintenance",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Maintenance Date",
                                rules: { notBeforePurchase: _vm.purchaseDate },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: { id: "example-Maintenance" },
                                          model: {
                                            value: _vm.maintainanceDate,
                                            callback: function ($$v) {
                                              _vm.maintainanceDate = $$v
                                            },
                                            expression: "maintainanceDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Location",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "mc-last-name",
                                placeholder: "Location",
                              },
                              model: {
                                value: _vm.location,
                                callback: function ($$v) {
                                  _vm.location = $$v
                                },
                                expression: "location",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Availability",
                              "label-for": "mc-last-name",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.optionsDLL },
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "6" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Cost Per Hour" } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Cost Per Hour",
                                rules: "nonNegative",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            placeholder: "Cost / Hour (RS)",
                                            step: "0.01",
                                          },
                                          model: {
                                            value: _vm.costPerHour,
                                            callback: function ($$v) {
                                              _vm.costPerHour = $$v
                                            },
                                            expression: "costPerHour",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-between",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              type: "submit",
                              variant: "primary",
                              disabled: _vm.loading,
                            },
                          },
                          [
                            _vm._v(" Submit "),
                            _vm.loading
                              ? _c("b-spinner", { staticClass: "mx-2" })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }